const DynamicImage = ({ image, className = "" }) => {
  const uploadUrl = process.env.REACT_APP_UPLOAD_URL;

  if (!image) return null;

  // If multiple media
  if (Array.isArray(image)) {
    return image.map((img) => (
      <img
        key={img.id}
        src={`${uploadUrl}${img.url}`}
        alt={img.alternativeText || "cyblox"}
        className={className}
      />
    ));
  }

  // Single media
  return (
    <img
      src={`${uploadUrl}${image.url}`}
      alt={image.alternativeText || "cyblox"}
      className={className}
    />
  );
};

export default DynamicImage;
